export interface Category {
  name: string;
  slug: string;
  url: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
  },
];